
 

 

 

 
class ResetPasswordUpdateRequest 
{
    
        TokenKey: string;
    
        UserUID: string;
    
        NewPassword: string;
    
        ConfirmPassword: string;
    
}
 
export default ResetPasswordUpdateRequest;
 




